import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {RelatedEntitiesWidgetFetchHandler} from "./related-entities-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";

export class RelatedEntitiesWidgetHandlers extends HandlerList {
  static injectables = [
    RelatedEntitiesWidgetFetchHandler,
    EntityClickEventHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    relatedEntitiesWidgetFetchHandler: RelatedEntitiesWidgetFetchHandler,
    entityClickEventHandler: EntityClickEventHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      relatedEntitiesWidgetFetchHandler,
      entityClickEventHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
